import {Component, ComponentRef, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {AppService} from "../../../../core/services/app.service";
import {ToastrService} from "ngx-toastr";
import {ReplyCommentService} from "../services/reply-comment.service";
import * as $ from 'jquery';
import {UserService} from "../../../user/services/user.service";
import {CamerallaAuthService} from "../../../../shared/services/authentication-services/cameralla-auth.service";

@Component({
    selector: 'app-comment-reply',
    templateUrl: './comment-reply.component.html',
})
export class CommentReplyComponent implements OnInit {
    constructor(private http: HttpClient, private toastr: ToastrService, private replyCommentService: ReplyCommentService, private userService: UserService, private authService: CamerallaAuthService,) {
    }

    public static replyCommentAPI = AppService.getApiUrl() + '/api/replyComments';

    @Input('comment') commentInfo: string = '';
    @Input('srcComment') srcComment: any;
    @Output('onSend') onSend: EventEmitter<any> = new EventEmitter<any>();
    onSending: boolean = false;
    userId;
    maxLength = 1000;
    userInfo = {
        avatar: './assets/images/default-avatar-small.png'
    };

    ngOnInit() {
        this.userId = +this.authService.getLocalUserInfo()['id'];
        this.userService.getPersonalDetails(this.userId).then((userInfo) => {
            this.userInfo = userInfo;
        });
    }

    ngAfterViewInit() {
       setTimeout(() =>{
           $('html, body').animate(
             {
                 scrollTop: $('#commentInfo').offset().top - $('main').offset().top + $('main').scrollTop() - 50
             }, 'slow');
       }, 300);


        $("#commentInfo").keypress((e) => {
            if (e.which == 13 && !e.shiftKey) {
                e.preventDefault();
                if (this.commentInfo.trim().length > 0) {
                    this.reply();
                }
            }
        });
    }

    reply() {
        this.onSending = true;
        this.replyCommentService.replyComment({
            content: this.commentInfo,
            customerId: this.userId,
            ratingId: this.srcComment.ratingId,
            comment_type: this.srcComment.commentType
        }).subscribe((data: any) => {
            //this.toastr.success('Add comment successfully', "Done");
            this.onSend.emit(data.Data);
        }, () => {
            this.onSending = false;
            this.toastr.success('Add comment fail', "Error");
        });
    }

    cancelComment() {
        this.onSend.emit();
    }
}
